import { useEffect, useState } from "react";
import { ArrowLeft } from "react-feather";
import { contribuyenteService } from "../../../../_services/contribuyente.service";
import excelIcon from "../../../../assets/static/images/icons/excel-icon.png";
import Loading from "./Loading";
import DescargarExcel from "../../../../components/DescargarExcel/DescargarExcel";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { Button } from "react-bootstrap";
import HistorialActuaciones from "../../MesaEntradasJudicial/Components/HistorialActuaciones";

const Contribuyente = ({ causa, setCausa }) => {
  const history = useHistory();

  const [values, setValues] = useState();
  const [loading, setLoading] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const [actuaciones, setActuaciones] = useState([]);

  const handleShowModal = (e) => {
    setActuaciones(e);
    setModalShow(true);
  };
  const handleCloseModal = () => {
    setActuaciones([]);
    setModalShow(false);
  };


  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        let response = await contribuyenteService.getContribuyente({ recurso: causa.RECURSO, imponible: causa.IMPONIBLE });

        if (response?.contribuyente) {
          setValues(response?.contribuyente);
          setLoading(false);
        }
        else {
          setValues("");
          setLoading(false);
        }
      }
      catch (err) {
        setValues("");
        setLoading(false);
      }
    };

    getData();

    return () => {
      setValues("");
    };

  }, [causa]);

  const handleBack = () => {
    setCausa(null);
  };

  function exportData(list) {
    const filename = `contribuyente_${new Date().getTime()}.xlsx`;
    const dataList = list;

    const name = "Contribuyente";

    return {
      dataList,
      filename,
      name
    };
  }

  const estados = {
    "a-tiempo": "Activo",
    "tiempo-cerca": "Activo",
    "vencido": "Vencido",
  };

  return (
    <>
      <div className="w-100 d-flex justify-content-start mb-3">
        <ArrowLeft onClick={handleBack} className="cursor-pointer text-sn" size={24} />
        <div className="w-100 fw-600 text-center" style={{ fontSize: 20 }}>
          Detalle contribuyente
        </div>
      </div>

      {loading ? (
        <Loading />
      ) : values ? (
        <div className="d-flex flex-column fw-600 mt-5" style={{ gap: 50 }} >
          <div className="d-flex flex-wrap" style={{ gap: 50 }} >
            <div>
              <div className="text-sn mb-2">PARTIDO</div>
              <div></div>
            </div>
            <div>
              <div className="text-sn mb-2">CIRCUNSCRIPCIÓN</div>
              <div>{causa.nomenclatura?.CIRC}</div>
            </div>
            <div>
              <div className="text-sn mb-2">SECCIÓN</div>
              <div>{causa.nomenclatura?.SECC}</div>
            </div>
            <div>
              <div className="text-sn mb-2">MANZANA</div>
              <div>{causa.nomenclatura?.MZ}</div>
            </div>
            <div>
              <div className="text-sn mb-2">PARCELA</div>
              <div>{causa.nomenclatura?.PC}</div>
            </div>
            <div>
              <div className="text-sn mb-2">PARTIDA INMOBILIARIA</div>
              <div>{causa.partida}</div>
            </div>
          </div>
          <div className="d-flex flex-wrap" style={{ gap: 50 }}>
            <div>
              <div className="text-sn mb-2">CONTRIBUYENTE</div>
              <div>{causa.apellnom || causa.APYNOM || ""}</div>
            </div>
            <div>
              <div className="text-sn mb-2">MESA ENTRADA</div>
              <div>{causa.mesa || ""}</div>
            </div>
            <div>
              <div className="text-sn mb-2">CATEGORÍA</div>
              <div>{causa.categoria}</div>
            </div>
            <div>
              <div className="text-sn mb-2">MONTO</div>
              <div></div>
            </div>
            <div>
              <div className="text-sn mb-2">FECHA LÍMITE EXT</div>
              <div>{causa?.fecha_limite}</div>
            </div>
          </div>
          <div className="d-flex flex-wrap" style={{ gap: 50 }}>
            <div>
              <div className="text-sn mb-2">HISTORIAL ACTUACIONES</div>
              <div>{
                causa?.imponibles?.length ?
                  causa.imponibles[causa.imponibles.length - 1].historico ? (
                    <div>
                      <div className="mb-2">{causa.imponibles[causa.imponibles.length - 1].historico?.SITUACION}</div>
                      <div>
                        <Button className="btn-outline" onClick={() => handleShowModal(causa.imponibles[causa.imponibles.length - 1])}>Ver todos</Button>
                      </div>
                    </div>
                  ) : causa.imponibles[causa.imponibles.length - 1].actuaciones?.length ? (
                    <div>
                      <div className="mb-2">{causa.imponibles[causa.imponibles.length - 1].actuaciones[0].SITUACION || causa.imponibles[causa.imponibles.length - 1].actuaciones[0].tipo_etapa?.nombre}</div>
                      <div>
                        <Button className="btn-outline" onClick={() => handleShowModal(causa.imponibles[causa.imponibles.length - 1])}>Ver todos</Button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="mb-2">Sin actuaciones</div>
                    </div>
                  ) : (
                    <div>
                      <div className="mb-2">Sin actuaciones</div>
                    </div>
                  )
              }
              </div>
            </div>
            <div>
              <div className="text-sn mb-2">FECHA ÚLTIMA ACTUACIÓN</div>
              <div>{causa?.fecha_inicial}</div>
            </div>
            <div>
              <div className="text-sn mb-2">ESTADO DE CAUSA</div>
              <div>
                <div className={`text-center ${!causa.sin_color ? causa.color_dias : ""}`}>
                  {causa.sin_color ? "Sin evaluar" : estados[causa.color_dias]}
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex mt-3" style={{ gap: 10 }}>
            <div>
              <button
                className="px-3"
                style={{ height: 50, backgroundColor: "var(--main-color)", borderRadius: 8, border: "none", color: "white" }}
                onClick={() => history.push(`/gestion?grupo=${causa.grupo}&tipo=${causa.tipo}&nombre=${causa.apellnom || causa.APYNOM}&imponible=${causa.IMPONIBLE || causa.NRO_IMPONIBLE || causa.imponible}&recurso=${causa.last_recurso || ""}&abogado=${causa.abogado || ""}`)}
              >
                Ir a gestión
              </button>
            </div>
            <div>
              <DescargarExcel
                data={exportData([])}
                style={{ height: 50, background: "#185C37", borderRadius: 8, border: "none", color: "white", padding: "0px 10px" }}
              >
                Exportar excel <img src={excelIcon} width={24} />
              </DescargarExcel>
            </div>
          </div>
        </div>
      ) : null}

      {modalShow && <HistorialActuaciones show={modalShow} handleClose={handleCloseModal} data={actuaciones} />}
    </>
  );
};


export default Contribuyente;